let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kQ83D")).then(() => parcelRequire('b5HUz'));